//DEV
export const environment = {
  name: 'development',
  production: false,
};
